import { NgxLoggerLevel } from "ngx-logger";

export const environment = {
  production: true,
  firebase: {
      apiKey: "AIzaSyB4FFo6fHnN5j8WPZhBHL_whf_7KptH260",
      authDomain: "daysvendingsite.firebaseapp.com",
      databaseURL: "https://daysvendingsite-default-rtdb.europe-west1.firebasedatabase.app",
      projectId: "daysvendingsite",
      storageBucket: "daysvendingsite.appspot.com",
      messagingSenderId: "501366643763",
      appId: "1:501366643763:web:bad0b6a91da219b030d746",
      measurementId: "G-P8B41VW490"
    },
    apiUrl: 'https://test-api.daysvending.pt:9098/',
    ivaTax: 23,
    DV_LOGGER_LEVEL: NgxLoggerLevel.WARN,
    DV_LOGGER_TIMESTAMP_FORMAT: 'yyyy-MM-dd HH:mm:ss zzz',
    DV_HTTP_TIMEOUT: 60000,
};
